export class Calculator {
  constructor(jsonData, $calculator) {
    this.jsonData = jsonData.countries;
    this.$calculator = $calculator;
    this.$country = this.$calculator.find('select[name="country"]');
    this.$deliveryType = this.$calculator.find('input[name^="delivery_type"]');
    this.$price = this.$calculator.find('.light-global-logistics-calc__price');
    this.$highCostZone = this.$calculator.find('input[name="high_cost_zone"]');
    this.$highCostZoneContainer = this.$calculator.find('.light-global-logistics-calc__high-cost-zone');
    this.$highCostZoneLabel = this.$calculator.find('.high-cost-zone__label');
    this.$weightSelect = this.$calculator.find('select[name="weight"]');
    this.$dimensions = this.$calculator.find('.light-global-logistics-calc__dimensions');

    this.initializeCalculator();
  }

  initializeCalculator() {
    this.$country.val('Россия');
    this.$deliveryType.first().prop('checked', true);

    this.$calculator.on('change input', 'input, select', this.handleInputChange.bind(this));
    this.$deliveryType.on('change', this.handleDeliveryTypeChange.bind(this));
    this.$country.on('change', this.handleCountryChange.bind(this));

    this.handleCountryChange();
    this.redrawOptionsFromData();
    this.calculatePrice();

    console.log('Calculator initialized');
    $('.light-global-logistics-calc__loading-overlay').hide();
  }

  handleCountryChange() {
    const selectedCountry = this.$country.val();
    const countryData = this.jsonData[selectedCountry];

    if (countryData.hasFarZones) {
      this.$highCostZoneContainer.show();
      this.$highCostZoneLabel.text(countryData.farZonesDescription || '');
    } else {
      this.$highCostZoneContainer.hide();
      this.$highCostZone.prop('checked', false);
    }

    this.redrawOptionsFromData();
    this.calculatePrice();
  }

  handleInputChange(event) {
    if (!$(event.target).is(this.$deliveryType)) {
      this.calculatePrice();
    }
  }

  handleDeliveryTypeChange(e) {
    e.target.checked = true;
    this.redrawOptionsFromData();
    this.calculatePrice();
  }

  redrawOptionsFromData() {
    const selectedCountry = this.$country.val();
    const deliveryType = this.getDeliveryType();
    const countryData = this.jsonData[selectedCountry];
    let weightOptions = countryData.prices[deliveryType];

    // Ensure weightOptions is an array
    if (!Array.isArray(weightOptions)) {
      weightOptions = Object.values(weightOptions);
    }

    this.$weightSelect.empty();
    weightOptions.forEach((range) => {
      const max = range.max === null ? '∞' : range.max;
      const text = max === '∞'
        ? `Свыше ${range.min} кг`
        : range.min === range.max
        ? `${range.min} кг`
        : `${range.min} кг — ${max} кг`;
      this.$weightSelect.append($('<option>', { value: JSON.stringify(range), text }));
    });
  }

  calculatePrice() {
    const selectedCountry = this.$country.val();
    const deliveryType = this.getDeliveryType();
    const isParcel = deliveryType === 'parcel';
    const isHighCostZone = this.$highCostZone.is(':checked');
    const countryData = this.jsonData[selectedCountry];

    this.toggleParcelOptions(isParcel);

    const { calculatedWeight } = this.calculateWeight(isParcel);

    const weightOptions = countryData.prices[deliveryType];
    const maxLimit = this.getMaxLimit(weightOptions);

    const selectedRange = JSON.parse(this.$weightSelect.val());
    let price;

    if (calculatedWeight > 0) {
      if (calculatedWeight <= selectedRange.max) {
        // Use the price from the selected weight range
        price = this.getPriceFromRange(selectedRange, isHighCostZone, countryData.hasFarZones);
        this.displayPrice(price, null, countryData); // Not indicating volumetric weight calculation
      } else {
        // Calculated weight exceeds selected range
        if (calculatedWeight > maxLimit) {
          this.displayVolumetricPrice(calculatedWeight, countryData);
          return;
        }

        const matchingRange = this.findMatchingWeightRange(weightOptions, calculatedWeight);

        if (matchingRange) {
          price = this.getPriceFromRange(matchingRange, isHighCostZone, countryData.hasFarZones);
          this.displayPrice(price, calculatedWeight, countryData); // Indicate volumetric weight calculation
        } else {
          // No matching range found, calculate volumetric price
          this.displayVolumetricPrice(calculatedWeight, countryData);
        }
      }
    } else {
      // Dimensions are not filled, use the selected weight range
      price = this.getPriceFromRange(selectedRange, isHighCostZone, countryData.hasFarZones);
      this.displayPrice(price, null, countryData);
    }
  }

  getDeliveryType() {
    return this.$deliveryType.filter(':checked').val() || 'parcel';
  }

  toggleParcelOptions(isParcel) {
    this.$dimensions.toggle(isParcel);
    if (!this.jsonData[this.$country.val()].hasFarZones) {
      this.$highCostZoneContainer.hide();
    } else {
      this.$highCostZoneContainer.toggle(isParcel);
    }
  }

  calculateWeight(isParcel) {
    let calculatedWeight = 0;

    if (isParcel) {
      const width = parseInt(this.$calculator.find('input[name="width"]').val()) || 0;
      const length = parseInt(this.$calculator.find('input[name="length"]').val()) || 0;
      const height = parseInt(this.$calculator.find('input[name="height"]').val()) || 0;

      if (width > 0 && length > 0 && height > 0) {
        calculatedWeight = Math.ceil((width * length * height) / 5000);
      }
    }

    return { calculatedWeight };
  }

  getMaxLimit(weightOptions) {
    return weightOptions.reduce((max, range) => {
      const rangeMax = range.max === null ? Infinity : range.max;
      return rangeMax > max && rangeMax !== Infinity ? rangeMax : max;
    }, 0);
  }

  findMatchingWeightRange(weightOptions, weight) {
    for (let range of weightOptions) {
      const max = range.max === null ? Infinity : range.max;
      if (weight >= range.min && weight <= max) {
        return range;
      }
    }
    return null;
  }

  getPriceFromRange(range, isHighCostZone, hasFarZones) {
    const priceIndex = isHighCostZone && hasFarZones ? 1 : 0;
    return range.prices[priceIndex] || range.prices[0];
  }

  displayVolumetricPrice(weight, countryData) {
    if(countryData.prices.overWeight !== null) {
      const pricePerKg = countryData.prices.overWeight;
      const price = pricePerKg * weight;
      this.$price.text(`${price.toFixed(0)} THB (расчет по объемному весу)`);
    }
    else {
      this.$price.text('Рассчитывается индивидуально');
    }
  }

  displayPrice(price, calculatedWeight, countryData) {
    if (!price) {
      if(countryData.prices.overWeight !== null) {
      this.$price.text(`${countryData.prices.overWeight} THB за кг`);
      }
      else {
        this.$price.text('Рассчитывается индивидуально');
      }
      return;
    }

    if (calculatedWeight > 0) {
      this.$price.text(`${price.toFixed(0)} THB (расчет по объемному весу)`);
    } else {
      this.$price.text(`${price.toFixed(0)} THB`);
    }
  }
}
